import { useSelector } from "react-redux";
import { Box, Grid, makeStyles, Typography } from "@material-ui/core";

import { currencyFormatter } from "../../../../services";
import { Icon } from "../../../../components/base";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  titleContainer: {
    marginLeft: theme.spacing(2.5),
  },
  row: {
    margin: theme.spacing(1),
  },
  description: {
    lineHeight: 2.5,
    marginLeft: theme.spacing(0.5),
  },
  iconBox: {
    width: 70,
    height: 70,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#F8F8F8",
    borderRadius: "100%",
    borderWidth: 1,
    borderStyle: "solid",
  },
}));

export const UnrealizedSource = ({
  img,
  imgBorderColor,
  assetName,
  titleContent,
  perYear,
  per20Y,
}) => {
  const classes = useStyles();
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);

  return (
    <div className={classes.root}>
      <Grid container alignItems="center">
        <Box className={classes.iconBox} style={{ borderColor: imgBorderColor }}>
          <Icon src={img} />
        </Box>
        <div className={classes.titleContainer}>
          {titleContent ? (
            titleContent
          ) : (
            <>
              <Typography variant="h3">0 kWh</Typography>
              <Typography variant="h4">{assetName} – to Install</Typography>
            </>
          )}
        </div>
      </Grid>

      <Grid className={classes.row} container>
        <Typography variant="h2">{currencyFormatter(perYear, currencySymbol)}</Typography>
        <Typography className={classes.description}>Unrealized rev./Y</Typography>
      </Grid>

      <Grid className={classes.row} container>
        <Typography variant="h2">{currencyFormatter(per20Y, currencySymbol)}</Typography>
        <Typography className={classes.description}>Unrealized rev./20Y Est.</Typography>
      </Grid>
    </div>
  );
};

UnrealizedSource.defaultProps = {
  perYear: 11200000,
  per20Y: 11200000,
};
